import { createAsyncThunk } from '@reduxjs/toolkit';
import { getFreshServicePodDataByTicketId } from 'services/pod';
import { IPodData } from 'services/pod/types';

interface IProps {
  psaId: number;
  ticketId: number;
}

export const getFreshServiceDataByTicketId = createAsyncThunk<IPodData, IProps>(
  'pod/getFreshServicePodData',
  async ({ psaId, ticketId }) => {
    const r = await getFreshServicePodDataByTicketId(psaId, ticketId);
    return r.data;
  },
);
